// extracted by mini-css-extract-plugin
module.exports = {"container":"navigation_container__ey0Rg","logo":"navigation_logo__89657"};